import React from 'react'
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';
import Section from '../Layout/Section/Section';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';
import Star from '../../components/Dividers/star';

import './photo-grid.scss';

function renderGridImages(images) {
  const gridImages = [];
  const delays = [0, 100, 200, 300]
  let delayIndex = 0;

  images.forEach((image, i) => {
    i++
    let starred = '';

    if (images.length%i === 0 || images.length%i === 3) {
      starred=`star--${images.length%i}`;
    } else if (image.featured) {
      starred='star--2';
    };

    if (delayIndex < 4) {
      delayIndex++
    } else {
      delayIndex = 0;
    }

    const animationDelay = {
      animationDelay: `${delays[delayIndex]}ms`
    }

    gridImages.push(
      <div key={i} style={animationDelay} className={`grid-image__container ${image.featured ? 'grid-image__container--featured' : '' }` }>
        <PreviewCompatibleImage
          customClassName={`grid-image ${image.featured ? 'grid-image--featured' : ''}` } imageInfo={image.image}
          alt="grid image" />
        {renderStar(starred)}
      </div>
    )
  })
  return gridImages;
}

function renderStar(starred) {
  if (starred) {
    return <Star customClass={starred}/>
  }
}

const photoGrid = ({gridImages}) => {

  return (
    <Section>
      <InnerContainer customClass="photo-grid">
        {renderGridImages(gridImages)}
      </InnerContainer>
    </Section>
  )
}

export default photoGrid;
